import axiosInstance from "./axiosInstance";

export const getTeamMembers = async () => {
  try {
    const response = await axiosInstance.get("/public/teammenber", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch team members");
  }
};

export const getTeamMemberById = async (id) => {
  try {
    const response = await axiosInstance.get(`/teammenberfetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch team member");
  }
};

export const createTeamMember = async (formData) => {
  try {
    const response = await axiosInstance.post("/teammenber", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create team member");
  }
};

export const updateTeamMember = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`/teamMember/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to update team member");
  }
};

export const deleteTeamMember = async (id) => {
  try {
    const response = await axiosInstance.delete(`/teammenberdel/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete team member");
  }
};